module.exports = __webpack_public_path__ + "static/media/historical-marker.ffb32e6a.svg";